import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CampaignLogsComponent } from '../../shared/dialogs/campaign-logs/campaign-logs.component';
import Swal from 'sweetalert2';
import { ProjectsProvidersResponseComponent } from '../../shared/dialogs/projects-providers-response/projects-providers-response.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ProjectsProvidersFormHistoryComponent } from '../../shared/dialogs/projects-providers-form-history/projects-providers-form-history.component';
import { ProjectsService } from 'src/app/services/projects.service';
import { MainService } from 'src/app/services/main.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectsProvidersViewConceptoFileComponent } from '../../shared/dialogs/projects-providers-view-concepto-file/projects-providers-view-concepto-file.component';
import { ProjectsProvidersImgAddFileComponent } from '../../shared/dialogs/projects-providers-view-img-file/projects-providers-view-img-file.component';
import { AuthService } from 'src/app/services/auth.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ProvidersSurveysLogsComponent } from '../../shared/dialogs/providers_surveys_logs/providers_surveys_logs.component';
import { UsersService } from 'src/app/services/users.service';


@Component({
  selector: 'app-projects-providers-view',
  templateUrl: './projects-providers-view.component.html',
  styleUrls: ['./projects-providers-view.component.scss']
})
export class ProjectsProvidersViewComponent implements OnInit {
  
  viewData : string = "";
  formMaterial!: FormGroup;
  dataGet : any = { provider_suv : null };
  bodyForm : FormData = new FormData(); 
  isLogged : boolean = false;
  formProvider!: FormGroup;
  id_provider_survey : number = 0;
  id_ps = 0;
  isUserView = false;
  surveyResponse : any = {};
  formulario : Array<any> = [];

  isLoadingFile = false;
  sanitizedFileSource!: SafeResourceUrl;

  isLoadingImg = false;
  sanitizedImgSource!: SafeResourceUrl;
  id_diagram:number = 0;
  archivos: any[] = [];
  mostrarCarruselImagenes = false;

  selectedImage!: string;
  currentIndex = 0;
  imagenesMultiple: any = [];
  company_img_lg : any;

  constructor(
    private matDialog: MatDialog,
    private fb: FormBuilder,
    private projectService : ProjectsService,
    private main : MainService,
    private _params: ActivatedRoute,
    private _router : Router,
    private auth: AuthService,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private users : UsersService
  ) { 
    this._params.params.subscribe(params => {
      console.log(params);
      if(params.id_usr){
        this.id_ps = params.id;
        console.log("surv id", this.id_ps);
        this.getPreView();
      }else{
        if(params.id){
          this.viewData = params.id;
          this.getView();
        }else{
          this._router.navigateByUrl('/login');
        }  
      } 
    });
  }

  ngOnInit(): void {
    this.checkIfLogged();
   
    if(this.isLogged){
      try{
        let dataAux : any =this.projectService.getTokenData(this.viewData)
         this.id_provider_survey =  dataAux.id_provider_survey;
      }catch{
        console.log("logged but not valid token");
      }

    }
    //this.createFormProvider();
     let user_info : any = this.users.getUser();
     console.log("cur user", user_info);
     this.company_img_lg = user_info.current_company.imagen.replace(
      '.png',
      '_lg.png'
    );
    //this.setValueToggles();
  }

  reloadUi(){
    this._params.params.subscribe(params => {
      console.log(params);
      if(params.id_usr){
        this.id_ps = params.id;
        this.getPreView();
      }else{
        if(params.id){
          this.viewData = params.id;
          this.getView();
        }else{
          this._router.navigateByUrl('/login');
        }  
      } 
    });
  }

  checkIfLogged(){
    this.isLogged = this.auth.isAuthenticated()
  }

  createFormProvider() {
    this.surveyResponse = {
      id_member : this.dataGet.memb_sts[0].id,
      id_provider_survey : this.dataGet.provider_suv[0].id,
      respuesta : "",
      aprobado : false,
      password : "",
      comentario : ""
    }
   //this.formProvider = this.fb.group({
   //  id_member : [this.dataGet.memb_sts[0].id],
   //  id_provider_survey : [this.dataGet.provider_suv[0].id],
   //  desc_producto : [true],
   //  sku : [true],
   //  imagen_vobo : [true],
   //  mec_promo : [true],
   //  pub_vobo : [true],
   //  razon_social : [this.dataGet.memb_sts[0].razon_social, [ Validators.required]],
   //  empresa_recuperadora : ["", [ Validators.required]],
   //  concepto : ["", [ Validators.required]],
   //  monto : ["", [ Validators.required,Validators.pattern(/^-?(0|[1-9]\d*)?$/) ]],
   //  metodo_pago : ["", [ Validators.required]],
   //  desc_producto_com : [""],
   //  sku_com : [""],
   //  imagen_vobo_com : [""],
   //  mec_promo_com : [""],
   //  pub_vobo_com : [""],
   //  password : [""],
   //});

   //this.bodyForm  = new FormData(); 
  }
  
  createFormProviderBasic() {
    this.surveyResponse = {
      id_member : 0,
      id_provider_survey : 0,
      respuesta : "",
      aprobado : false,
      password : "",
      comentario : ""
    }
  //this.formProvider = this.fb.group({
  //  id_member : [0],
  //  id_provider_survey : [0],
  //  desc_producto : [true],
  //  sku : [true],
  //  imagen_vobo : [true],
  //  mec_promo : [true],
  //  pub_vobo : [true],
  //  razon_social : ["", [ Validators.required]],
  //  empresa_recuperadora : ["", [ Validators.required]],
  //  concepto : ["", [ Validators.required]],
  //  monto : ["", [ Validators.required,Validators.pattern(/^-?(0|[1-9]\d*)?$/) ]],
  //  metodo_pago : ["", [ Validators.required]],
  //  desc_producto_com : [""],
  //  sku_com : [""],
  //  imagen_vobo_com : [""],
  //  mec_promo_com : [""],
  //  pub_vobo_com : [""],
  //  password : [""],
  //});

  //this.bodyForm  = new FormData(); 
  }

  createFormMaterial() {
    this.formMaterial = this.fb.group({
      toggle1: ['', [ Validators.required]]
    });
  }

  openDialogChat() {
    console.log(this.id_provider_survey);
    this.matDialog.open(ProvidersSurveysLogsComponent, {
      panelClass: ['dialogs-md'],
      data: {
          id_provider_survey : this.id_provider_survey
      }
    }).afterClosed().subscribe(
      resp => {
      }
    );
  }

  locked : boolean = false;
  deleted : boolean = true;

  getView(){
    //this.removeFileImg()
    //this.removeFileConcepto();
    this.main.ShowLoading();
    this.projectService.getProviderView(this.viewData).subscribe(
      (result:any) => {
       this.main.HideLoading();
       this.dataGet = result.data;

       console.log("THIS DATA GET")
       console.log(this.dataGet)


        if(!this.dataGet.provider_suv[0] || this.dataGet.provider_suv.length == 0){
          this.deleted = true;
           Swal.fire({
            icon: 'warning',
            title: 'No se encontró ningún formulario',
            text: 'Por favor verifique los datos e intente de nuevo',
            allowOutsideClick: false,
            showConfirmButton: false
          });
        }else{
          this.deleted = false;
          this.id_diagram = this.dataGet.provider_suv[0].id_proyecto_diagrama;
          this.getFormulario();    
          this.loadFileById(this.dataGet.provider_suv[0].id);
          if(this.dataGet.provider_suv[0].locked == 1){
          this.locked = true;
          Swal.fire({
            icon: 'warning',
            title: 'Este formulario se encuentra bloqueado',
            text: 'No puede responder este formulario por que se encuentra bloqueado',
            allowOutsideClick: false,
            showConfirmButton: true
          });
        }

        if(this.dataGet.provider_suv[0].status == 2){
          this.locked = true;
          Swal.fire({
            icon: 'warning',
            title: 'Este formulario se encuentra aprobado.',
            text: 'Ya no puede responder este formulario por que ya se encuentra aprobado',
            allowOutsideClick: false,
            showConfirmButton: true
          });
        }

         if(this.dataGet.provider_suv[0].status == 3){
          this.locked = true;
          Swal.fire({
            icon: 'warning',
            title: 'Formulario rechazado.',
            text: 'Este formulario ya no puede ser modificado',
            allowOutsideClick: false,
            showConfirmButton: true
          });
        }

       this.createFormProvider();
       console.log(this.dataGet);
        }


      },
      (err:any) => {
        this.main.HideLoading();
          Swal.fire({
            icon: 'error',
            title: 'Error al obtener registros',
            text: 'Ocurrió un error al obtener los registros de proveedores.'
          });
        
      }
    );
  }

  getPreView(){
   // this.removeFileImg()
   // this.removeFileConcepto();
    this.main.ShowLoading();
    this.projectService.getProviverSurveyPreview(this.id_ps).subscribe(
      (result:any) => {
       this.main.HideLoading();
       this.dataGet = result.data;
       this.locked = true;
       this.isUserView = true;
       console.log("get data preview", result.data);
      this.deleted = true;
       if(!this.dataGet.provider_suv || this.dataGet.provider_suv.length == 0){
          this.deleted = true;
           Swal.fire({
            icon: 'warning',
            title: 'No se encontró ningún formulario',
            text: 'Por favor verifique los datos e intente de nuevo',
            allowOutsideClick: false,
            showConfirmButton: false
          });
        }else{
          this.deleted = false;
          this.id_diagram = this.dataGet.provider_suv[0].id_proyecto_diagrama;
          this.getFormulario();    
          this.loadFileById(this.id_ps);
        if(this.dataGet.provider_suv[0].locked == 1){
          this.locked = true;
          Swal.fire({
            icon: 'warning',
            title: 'Este formulario se encuentra bloqueado',
            text: 'No puede responder este formulario por que se encuentra bloqueado',
            allowOutsideClick: false,
            showConfirmButton: true
          });
        }
        if(this.dataGet.provider_suv[0].status == 2){
          this.locked = true;
          Swal.fire({
            icon: 'warning',
            title: 'Este formulario se encuentra aprobado',
            text: 'Ya no puede responder este formulario por que ya se encuentra aprobado',
            allowOutsideClick: false,
            showConfirmButton: true
          });
        }

        if(this.dataGet.provider_suv[0].status == 3){
          this.locked = true;
          Swal.fire({
            icon: 'warning',
            title: 'Formulario rechazado.',
            text: 'Este formulario ya no puede ser modificado',
            allowOutsideClick: false,
            showConfirmButton: true
          });
        }

       this.createFormProviderBasic();
       console.log(this.dataGet);
       }
      },
      (err:any) => {
        this.main.HideLoading();
          Swal.fire({
            icon: 'error',
            title: 'Error al obtener registros',
            text: 'Ocurrió un error al obtener los registros de proveedores.'
          });
        
      }
    );
  }

  loadFileById(id: number) {
    if (!id) return;

    this.archivos = [];
    this.imagenesMultiple = [];
    this.selectedImage = '';
    this.mostrarCarruselImagenes = false;
    this.isLoadingFile = true;

    // El archivo asociado al survey es la fuente principal del preview. en el flujo tradicional contiene la url copiada del arte individual y, para artes compartidos, contiene la url del recorte generado
    this.cargarArchivoDelSurvey(id, true);

    console.log("ID"+id)
  }

  private cargarCarruselLegado(): void {

    const data = {
        id_diagrama: this.id_diagram,
        id_fase: 0
    }

    this.projectService.getdiagramFiles(data).subscribe((x: any) => {
      this.archivos = Array.isArray(x?.dataF) ? x.dataF : [];
      console.log("ARCHIVOS")
      console.log(this.archivos)

      // El carrusel se conserva para los surveys tradicionales cuyo arte era  un contenedor de multiples imagenes.
      if (this.archivos.length > 0 && this.archivos[0]?.file == null) {
        this.mostrarCarruselImagenes = true;

        const data = {
          id: this.archivos[0]?.id,
        }
        this.projectService.getDiagramaArchivosImages(data).subscribe((x: any) => {
          x.data.map((item:any) => {
            this.imagenesMultiple.push(item.file)
          })
          this.selectedImage = this.imagenesMultiple[0];
          this.isLoadingFile = false;
          this.main.HideLoading();
        },
        (err:any) => {
          console.log(err);
              this.main.HideLoading();
        })

      } else {
        this.isLoadingFile = false;
        this.main.HideLoading();
        Swal.fire('Error', 'No se pudo cargar el archivo asociado al survey.', 'error');
      }

    },
    (err:any) => {
      console.log(err);
      this.isLoadingFile = false;
      this.main.HideLoading();
      Swal.fire('Error', 'No se pudo cargar el archivo asociado al survey.', 'error');
    })
  }

  private cargarArchivoDelSurvey(id: number, usarRespaldoLegado = false): void {
    this.mostrarCarruselImagenes = false;
    this.projectService.getProviderViewerBlob(id).subscribe(
      (blob: Blob) => {
        const objectUrl = URL.createObjectURL(blob);
        this.sanitizedFileSource = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
        this.isLoadingFile = false;
        this.main.HideLoading();
      },
      (error: any) => {
        console.error('Error al cargar el archivo principal para previsualizar:', error);
        if (usarRespaldoLegado) {
          this.cargarCarruselLegado();
        } else {
          this.isLoadingFile = false;
          this.main.HideLoading();
          Swal.fire('Error', 'No se pudo cargar el archivo principal para previsualizar.', 'error');
        }
      }
    );
  }



  getFormulario(){
    let formularioAux = JSON.parse(this.dataGet?.provider_suv[0]?.formulario);
    this.formulario = formularioAux.map((x:any)=> ({ id: x.id, nombre : x.nombre, respuesta : true, comentario : "" }));
  }

  detectViewChange(){
    this.cdr.detectChanges();
  }

  ruSure() {
      if(this.dataGet.memb_sts[0].can_edit == 1){
        
        Swal.fire({
          title: this.formulario.some((x: any) => x.respuesta === false) ? '¿Está seguro que deseas desaprobar el material?' : '¿Está seguro que deseas aprobar el material?',
          text: 'Por favor, ingresa tu contraseña para confirmar tus cambios.',
          icon: 'warning',
          input: 'password',
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
         // footer: '<a href="">Olvidé mi contraseña</a>'
        }).then((result) => {      
          if (result.isConfirmed) {
            this.surveyResponse.password = result.value;
            this.savePasswordResponse();
          }
        });
      }
  }

 private savePasswordResponse(){
    Swal.fire({
      icon: 'info',
      title: 'Guardando...',
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.surveyResponse.aprobado = this.formulario.every(item => item.respuesta);
    this.surveyResponse.respuesta = JSON.stringify(this.formulario);
    console.log("saving")
    this.projectService.saveResponse(this.surveyResponse).subscribe(
      (result:any) => {
     // if(result.message == "Success") {
     //  Swal.fire({
     //    icon: 'success',
     //    title: 'Guardado',
     //    text: 'Respuesta guardada de manera correcta!'          
     //  }).then(() => {            
     //    this.getView();
     //  });
     // 
     // 
     // }
        console.log("respuesta guardada, subiendo imagenes", result.id_response);
        this.uploadImg(result.id_response)
      },
      (err:any) => {
        if(err.error.message.indexOf("Member not valid") > -1)
        {
          Swal.fire({
            icon: 'error',
            title: 'Contraseña no válida',
            text: 'La contraseña es incorrecta.'
          });
        }
        else {
          console.log(err);
          Swal.fire({
            icon: 'error',
            title: 'Error al guardar',
            text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
          });
        }

        
      }
    );
  }

  openDialogReject() {
    this.matDialog.open(ProjectsProvidersResponseComponent, {
      panelClass: ['dialogs-sm'],
      data: {}
    }).afterClosed().subscribe(
      resp => {
      }
    );
  }
  
  openDialogFormHistory() {
    this.matDialog.open(ProjectsProvidersFormHistoryComponent, {
      panelClass: ['dialogs-lg'],
      data: {
        responses : this.dataGet?.responses,
        files : this.dataGet?.files,
        nombre_proveedor : this.dataGet?.provider_suv[0]?.nombre_proveedor,
        folder : this.dataGet?.provider_suv[0]?.folder
      }
    }).afterClosed().subscribe(
      resp => {
      }
    );
  }

  fileComentario: File[] = [];

  fileConcepto: File | undefined = undefined;
  fileImage: File | undefined = undefined;


  openUploadFileComentario() {
    this.matDialog.open(ProjectsProvidersViewConceptoFileComponent, {
      panelClass: ['dialogs-sm'],
      data: {
      }
    }).afterClosed().subscribe(
      resp => {
        if (resp && resp.files) {
          this.fileComentario = [...(this.fileComentario || []), ...resp.files];
          console.log(this.fileComentario);
        }
      }
    );
  }


  openUploadFileConcepto() {
    this.matDialog.open(ProjectsProvidersViewConceptoFileComponent, {
      panelClass: ['dialogs-sm'],
      data: {
      }
    }).afterClosed().subscribe(
      resp => {
        this.fileConcepto = resp.file;
        console.log( this.fileConcepto );
      }
    );
  }

  openUploadFileImg() {
    this.matDialog.open(ProjectsProvidersImgAddFileComponent, {
      panelClass: ['dialogs-sm'],
      data: {
      }
    }).afterClosed().subscribe(
      resp => {
        this.fileImage = resp.file;
        console.log(this.fileImage);
      }
    );
  }

  uploadImg(id_resp : number){
    console.log("uploading files")
    this.bodyForm.append("id_provider_survey_response", id_resp.toString());
    this.bodyForm.append("id_member", this.dataGet.memb_sts[0].id);
    this.bodyForm.append("password", this.surveyResponse.password);
    this.bodyForm.append("folder", this.dataGet?.provider_suv[0]?.folder);
    (this.fileComentario as File[]).forEach(file => {
      this.bodyForm.append("blob", file, file.name);
  })

    this.projectService.uploadProviderResponseFile(this.bodyForm).subscribe(
      (result:any)=>{
        if(result.message == 'Success'){
            Swal.fire({
            icon: 'success',
            title: 'Guardado',
            text: 'Respuesta guardada de manera correcta!'          
          }).then(() => {            
            this.getView();
          });
        }
        else {
          Swal.fire({
            icon: 'success',
            title: 'Guardado.',
            text: 'Respuesta guardada de manera correcta!'          
          }).then(() => {            
            this.getView();
          });
        }
      },
      (err:any)=>{
        this.main.HideLoading();
        Swal.fire({
          icon: 'success',
          title: 'Guardado',
          text: 'Respuesta guardada de manera correcta!'          
        }).then(() => {            
          this.getView();
        });
      }
    )

  }

  removeFileImg(){
   this.fileImage = undefined;
  }

  removeFileConcepto(){
    this.fileConcepto = undefined;
  }

  removeFileComentario(index: number) {
    this.fileComentario = this.fileComentario.filter((_, i) => i !== index);
  }

  limpiarFormulario() {
    this.getFormulario();
    this.surveyResponse.comentario = "";

    this.fileComentario = [];
  }

   changeImage(index: number) {
    this.currentIndex = index;
    this.selectedImage = this.imagenesMultiple[index];
  }

   prevImage() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.selectedImage = this.imagenesMultiple[this.currentIndex];
    }
  }

  nextImage() {
    if (this.currentIndex < this.imagenesMultiple.length - 1) {
      this.currentIndex++;
      this.selectedImage = this.imagenesMultiple[this.currentIndex];
    }
  }
}
